// Dictionary
export const APIGetDictionary ="/dictionary/getDictionaryLanguageTranslations?lang=";
//Favorite Team
export const APIGetTeamList ="/dictionary/getTeamListByIni?initiativeId=";
//Get Minors -- gigya -> tutor
export const APIGetTutorsMinors = "/tutor/getTutorMinors";
//Get Minor
export const APIGetAccountnfo = "/account/getAccountInfo";

//Enable Child
export const APIEnableChild = "/child/enableChild";
//Update Child
export const APIUpdateChild = "/child/updateChildInfos";
//Delete Child -put-
export const APIDeleteChild = "/account/deleteUser";

//Delete Child -put-
export const APIDisableChild = "/account/disableUser";
//download dati {uid:} -post-
export const APIDownloadUserDati = "/account/downloadUserData";

//verify tutor
export const APIVerifyTutor = "/account/verifyUser";




